import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { AbstractControl } from '@angular/forms';
import { FileValidator } from '../../validators/file.validator';
import { ImageValidator, Ratio } from '../../validators/image.validator';
import {FIELD_BACKGROUND_IMAGE_SIZE_ERROR} from '../../../core/constants/validation-error-strings.constants';

@Component({
  selector: 'app-image-input-field[control]',
  templateUrl: './image-input-field.component.html',
  styleUrls: ['./image-input-field.component.scss'],
})
export class ImageInputFieldComponent implements OnInit {

  private readonly DEFAULT_MAX_IMAGE_FILE_SIZE_MB = 5;

  @ViewChild('imageFileInput') imageFileInput: ElementRef<HTMLInputElement>
  @Input() controlKey: string = 'image';
  @Input() extensions: string[] = ['jpg', 'jpeg', 'png'];
  @Input() allowedDimensions: { width: number, height: number }[] = [];
  @Input() allowedRatios: Ratio[] = [];
  @Input() maxSizeMb: number = this.DEFAULT_MAX_IMAGE_FILE_SIZE_MB;
  @Input() control: AbstractControl;
  @Input() title: string;
  @Input() withPreview: boolean = true;
  @Input() subtitle: string;

  extensionsString: string;

  ngOnInit(): void {
    this.control.setValidators([
      FileValidator.fileMaxSize(this.maxSizeMb),
      ...(this.allowedDimensions.length ? [ImageValidator.imageDimensionInPx(this.allowedDimensions)] : []),
      ...(this.allowedRatios.length ? [ImageValidator.imageDimensions(this.allowedRatios, 10)] : [])
    ]);

    this.extensionsString = this.extensions.map((ext) => `image/${ext}`).join(', ');
  }

  public onImageSelected(e: Event): void {
    const fileList = (e.currentTarget as HTMLInputElement).files;
    this.validateImage(fileList, this.control);
  }

  private validateImage(fileList: FileList, imageControl: AbstractControl): void {
    if (!fileList.length) {
      return;
    }

    const file = fileList.item(0);
    const fileReader: FileReader = new FileReader();

    fileReader.onload = (e: ProgressEvent<FileReader>) => {
      const image = new Image();
      image.src = e.target.result.toString();

      image.onload = (imageLoadEvent: Event) => {
        const width = imageLoadEvent.currentTarget['width'];
        const height = imageLoadEvent.currentTarget['height'];
        const dimensions = { width, height };

        imageControl.setValue({
          dimensions,
          size: file.size,
          filename: file.name,
          src: e.target.result,
          file
        });
      }
    }
    fileReader.readAsDataURL(file);
  }

  public clearSelectedBackground(event: Event): void {
    this.imageFileInput.nativeElement.value = '';
    this.control.setValue(null);
    this.control.updateValueAndValidity();
    event.stopPropagation();
  }

  protected readonly FIELD_BACKGROUND_IMAGE_SIZE_ERROR = FIELD_BACKGROUND_IMAGE_SIZE_ERROR;
}
